import DPSwitch from "framework/components/DPSwitch"
import React, { useState } from 'react'
import { Button, Row, Col, Container, FormGroup, Label, Input, Form } from 'reactstrap'
import _ from 'lodash';

import { useEffect } from 'react';
import { DecimalValidation } from "framework/validators/TextValidation";

export default function LocationMasterGenStoles({ propLR_LOCCODE, propAUTO_CODE, stoleList, setStoleList, disabled, clearData }) {
    const [newLocation, setNewLocation] = useState();
    const [LR_LOCCODE, setLR_LOCCODE] = useState(propLR_LOCCODE);

    const [newStoleName, setNewStoleName] = useState('');
    const [newStoleSqft, setNewStoleSqft] = useState('0.00');

    useEffect(() => {
        setNewStoleName('');
        setNewStoleSqft('0.00');
    }, [clearData])


    function addStole() {
        if (!newStoleName || !newStoleSqft || isNaN(newStoleSqft)) return;
        var currentStoles = stoleList;
        var max = 1;
        if (currentStoles.length > 0) {
            max = _getMax(currentStoles, 'lR_CODE').lR_CODE;
            max = parseInt(max) + 1;
            max = max.toString();
        }

        var roundSqft = (Math.round(newStoleSqft * 100) / 100).toFixed(2);
        currentStoles.push({ lR_CODE: max, lR_DESC: _.trim(newStoleName), lR_SQFT: roundSqft, lR_STATUS: true });
        setStoleList(currentStoles);
        setNewStoleName('');
        setNewStoleSqft('0.00');

    }

    function _getMax(arr, prop) {
        var max;
        for (var i = 0; i < arr.length; i++) {
            if (max == null || parseInt(arr[i][prop]) > parseInt(max[prop]))
                max = arr[i];
        }
        return max;
    }

    function handleRemove(remove_index) {
        //alert("Remove " + remove_index);
        var currentStoles = stoleList;
        var newStoles = [];
        for (var i = 0; i < stoleList.length; i++) {
            if (i != remove_index) {
                newStoles.push(currentStoles[i]);
            }
        }
        setStoleList(newStoles);
    }

    function handleStoleNameChange(e, values, index) {
        //var newStoleList = _.set(stoleList,`[${index}].LR_DESC`, e.target.value);

        const change = values;
        var newValue = e.target.value;
        if ((e.target.value).length == 0) newValue = "-";
        change.lR_DESC = newValue;
        var newStoles = [];
        for (var i = 0; i < stoleList.length; i++) {
            if (i == index) {
                newStoles.push(change);
            } else {
                newStoles.push(stoleList[i]);
            }
        }
        setStoleList(newStoles);
    }

    function handleStoleActivation(e, values, index) {
        values.lR_STATUS = e;
        var newStoles = [];
        for (var i = 0; i < stoleList.length; i++) {
            if (i == index) {
                newStoles.push(values);
            } else {
                newStoles.push(stoleList[i]);
            }
        }
        setStoleList(newStoles);
    }

    function handleStoleSqftChange(e, values, index) {
        const change = values;
        const newValue = e.target.value;
        if (isNaN(newValue)) return;
        var roundSqft = (Math.round(newValue * 100) / 100).toFixed(2);
        change.lR_SQFT = roundSqft;
        var newStoles = [];
        for (var i = 0; i < stoleList.length; i++) {
            if (i == index) {
                newStoles.push(change);
            } else {
                newStoles.push(stoleList[i]);
            }
        }
        setStoleList(newStoles);
    }

    //Load current location rentals list
    /* useEffect(async () => {
        let fetch = await loadRentals(propLR_LOCCODE);
        fetch = setStoleList(fetch);
    }, []); */

    useEffect(() => {
        if (propLR_LOCCODE) {
            setLR_LOCCODE(propLR_LOCCODE);
            setNewLocation(false);
        } else if (propAUTO_CODE) {
            setLR_LOCCODE(propAUTO_CODE);
            setNewLocation(true);
        } else {
            setNewLocation(true);
        }
    })

    // render content
    return (
        <Container fluid>
            <hr />
            <Row>
                <Col>
                    <b style={{ float: 'left' }}>Location Rentals</b>
                </Col>
            </Row>
            <br />
            <Form hidden={false}>
                <FormGroup row style={{ marginBottom: '10px' }}>
                    <Label size='sm' sm={3}>Rental Name</Label>
                    <Col sm={8}>
                        <Input disabled={disabled} required size={'sm'} placeholder="Rental Name" labelText={'Rental Name'} value={newStoleName} onChange={(e) => { setNewStoleName(e.target.value) }} />
                    </Col>
                </FormGroup>
                <FormGroup row style={{ marginBottom: '10px' }}>
                    <Label size='sm' sm={3}>Floor Area</Label>
                    <Col sm={8}>
                        <Input disabled={disabled} required size={'sm'}
                            type="text" style={{ textAlign: 'right' }}
                            labelText={'Floor Area'}
                            placeholder="Square Feet" value={newStoleSqft}
                            onChange={(e) => {
                                if (!isNaN(e.target.value))
                                    setNewStoleSqft(e.target.value)
                            }}
                            onBlur={(e) => {
                                let currentValue = DecimalValidation(e.target.value, 0, true, 2)
                                setNewStoleSqft(currentValue)
                            }}
                        />
                    </Col>
                    <Col sm={1} hidden={disabled}>
                        <Button size='sm' disabled={(!newStoleName || !newStoleSqft || isNaN(newStoleSqft))} color="success" onClick={() => { addStole() }}>
                            <i
                                className="mdi mdi-plus"
                            //style={{ fontSize: "12px" }}
                            ></i>
                        </Button>
                    </Col>
                </FormGroup>
            </Form>

            <center>{
                (stoleList.length == 0) ? <div><p><small><i>No stoles to display!</i></small></p></div> :
                    <Row style={{ fontWeight: 'bolder' }}>
                        <Col lg="1" xl="1">#</Col>
                        <Col lg="4" xl="4">Stole Name</Col>
                        <Col lg="4" xl="4">Sq. Ft.</Col>
                        <Col lg="2" xl="2">Active</Col>
                        <Col lg="1" xl="1"></Col>
                    </Row>
            }</center>

            {
                stoleList.map((values, index) => {
                    return (
                        <Row key={index} style={{ marginBottom: '5px' }}>
                            <Col lg="1" xl="1" style={{ marginTop: '5px' }}>
                                {index + 1}
                            </Col>
                            <Col lg="4" xl="4">
                                <Input size='sm' disabled={disabled} value={values.lR_DESC} onChange={(e) => { handleStoleNameChange(e, values, index) }} />
                            </Col>
                            <Col lg="4" xl="4">
                                <Input size='sm' disabled={disabled} type='number' style={{ textAlign: 'right' }} step={0.01} min={0.01} value={values.lR_SQFT} onChange={(e) => { handleStoleSqftChange(e, values, index) }} />
                            </Col>
                            <Col lg="2" xl="2">
                                <DPSwitch handleDiameter={0} disabled={disabled} value={true} checked={values.lR_STATUS} onChange={(e) => handleStoleActivation(e, values, index)} />
                            </Col>
                            <Col lg="1" xl="1" hidden={disabled}>
                                <Button className="btn-sm" color="danger" onClick={() => { handleRemove(index) }}>
                                    <i
                                        className="mdi mdi-delete"
                                    //style={{ fontSize: "12px" }}
                                    ></i>
                                </Button>
                            </Col>
                        </Row>
                    )
                })
            }
            <hr />
        </Container>
    )
}
